import gql from 'graphql-tag';

export default gql`
  mutation importUpdateDimweight($path: String!) {
    importUpdateDimweight(path: $path) {
      succeed
    }
  }
`;
